// casl-setup.js
import { abilitiesPlugin } from '@casl/vue';
import ability from './ability';  // Your ability configuration

export default function setupCASL(app) {
  app.use(abilitiesPlugin, ability, {
    useGlobalProperties: true
  })
}
